import type { RootState } from 'react-redux';

export const getIsViewingOtherUser = (state: RootState) => {
  return state.profileById.isViewingOtherUser;
};

export const getProfileById = (state: RootState) => {
  return state.profileById.data;
};

export const getOtherUserId = (state: RootState) => {
  return state.profileById.data.userId;
};

export const getIsProfileByIdLoading = (state: RootState) => {
  return state.profileById.loading;
};
